import DashboardIcon from '@/components/icons/sidebar/DashboardIcon';
import MaintenanceIcon from '@/components/icons/sidebar/MaintanceIcon';
import MessagesIcon from '@/components/icons/sidebar/messages';
import SupportIcon from '@/components/icons/sidebar/ChatIcon';
import TwoUsersIcon from '@/components/icons/sidebar/TwoUsersIcon';

export const navigationBottom = [
    { name: 'messages', icon: MessagesIcon, activeIcon: MessagesIcon, to: '' },
    { name: 'settings', icon: MaintenanceIcon, activeIcon: MaintenanceIcon, to: '' },
    { name: 'help_and_support', icon: SupportIcon, activeIcon: SupportIcon, to: '' },
];

export const customerRelations = [
    { name: 'customer_communication', to: '/customer-relations/customer-communication' },
    { name: 'complaints', to: '/customer-relations/complaints' },
    { name: 'marketing', to: '/customer-relations/marketing' },
];

export const navigation = [
    { name: 'dashboard', icon: DashboardIcon, activeIcon: DashboardIcon, to: '/' },

    {
        name: 'offers',
        icon: TwoUsersIcon,
        activeIcon: TwoUsersIcon,
        to: '/offers',
        // navigation: customerRelations,
    },

    // {
    //     name: 'maintenance',
    //     icon: MaintenanceIcon,
    //     activeIcon: MaintenanceIcon,
    //     to: '/maintenance',
    //     navigation: carsMaintenance,
    // },
];
